export const dxCommonMessages = {
    'pt-BR': {
      'OK': 'OK',
      'Cancel': 'Cancelar',
      'Apply': 'Aplicar',
      'Save': 'Salvar',
      'Close': 'Fechar',
      'Yes': 'Sim',
      'No': 'Não'
    },
    'en-US': {
      'OK': 'OK',
      'Cancel': 'Cancel',
      'Apply': 'Apply',
      'Save': 'Save',
      'Close': 'Close',
      'Yes': 'Yes',
      'No': 'No'
    },
    'es-ES': {
      'OK': 'Aceptar',
      'Cancel': 'Cancelar',
      'Apply': 'Aplicar',
      'Save': 'Guardar',
      'Close': 'Cerrar',
      'Yes': 'Sí',
      'No': 'No'
    }
};